"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCssProps = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _excluded = ["size", "sizes", "radius", "radiuses"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var COLOR_REGEX = /color/i;
var INTEGER_REGEX = /size|space|width|height|radius|gutter/i;
var convertToInt = function convertToInt(value) {
  if (typeof value === 'string') {
    if (!value.endsWith('%')) {
      return parseInt(value, 10);
    }
  }
  return value;
};
var getTokenValue = function getTokenValue(values, value) {
  if (values) {
    if (typeof value === 'string') {
      return values[value.replace('$', '')] || value;
    }
    return values[value] || value;
  }
  return null;
};
var getInitialProps = function getInitialProps(_ref) {
  var size = _ref.size,
    sizes = _ref.sizes,
    radius = _ref.radius,
    radiuses = _ref.radiuses,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return _objectSpread(_objectSpread({}, props), {}, {
    size: getTokenValue(sizes, size),
    radius: getTokenValue(radiuses, radius)
  });
};
var useCssProps = function useCssProps(originalProps) {
  var cssProps = getInitialProps(originalProps);
  Object.keys(cssProps).forEach(function (key) {
    var value = cssProps[key];
    if (COLOR_REGEX.test(key)) {
      cssProps[key] = value;
    } else if (INTEGER_REGEX.test(key)) {
      cssProps[key] = convertToInt(value);
    } else {
      cssProps[key] = value;
    }
    if (!cssProps[key]) {
      delete cssProps[key];
    }
  });
  return cssProps;
};
exports.useCssProps = useCssProps;